import React from "react";
import styled from "styled-components";
import { H5, P } from "../Texts";

import ashEllipse from "../../../assets/images/ash-ellipse.svg";
import penImg from "../../../assets/images/pen.svg";
import { PrimaryButton } from "../Buttons";

const TeamsCardStyle = styled.div`
  border-radius: 6px;
  width: ${(props) => props.width || "100%"};
  box-shadow: 0px 0px 1px rgba(37, 37, 37, 0.06);
`;

export const TeamCard = ({
  description,
  email,
  title,
  width,
  member,
  editMember,
}) => {
  return (
    <TeamsCardStyle
      width={width}
      className="bg-white py-6 px-5 flex justify-between duration-300"
    >
      <div className="flex items-center">
        {member.avatarUrl ? (
          <img src={member.avatarUrl} alt="" className="h-10 w-12" />
        ) : (
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center object-cover profile-dropdown-child"
            style={{ background: "#EAE7FE" }}
          >
            <H5 color="#12046D" className="capitalize profile-dropdown-child">
              {`${member?.firstName?.[0]} ${member?.lastName?.[0]}`}
            </H5>
          </div>
        )}
        <div className="ml-10 flex-grow truncate">
          <H5
            color="#22202D"
            fontSize="16px"
            smallSize="16px"
            className="mb-0 font-semibold"
          >
            {title}
          </H5>
          <div className="flex truncate">
            <P color="#413E53" fontSize="14px" smallSize="14px" className="my-0">
              {description}
            </P>
            <img src={ashEllipse} alt="" className="h-2 w-2 mt-2 mx-2 " />
            <P
              color="#413E53"
              fontSize="14px"
              smallSize="14px"
              className="my-0 truncate"
            >
              {email}
            </P>
          </div>
        </div>
      </div>
      <div className="">
        <PrimaryButton.Light
          p="4px 8px"
          className="flex items-center font-extrabold cursor-pointer"
          style={{ backgroundColor: "#DCD6FE", borderRadius: "3px" }}
          onClick={() => editMember(member)}
        >
          <P color="#442ED0" fontSize="13px">
            Edit
          </P>
          <img src={penImg} alt="" className="h-3 w-3 ml-4" />
        </PrimaryButton.Light>
      </div>
    </TeamsCardStyle>
  );
};
